import ShortlistIcon from '@components/icons/ShortlistIcon'
import AddIcon from '@mui/icons-material/Add'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProfileItemRoundButton = styled(Button)`
  border-radius: 18px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-wrap: nowrap;
  white-space: nowrap;
`

export const EmptyProfileItemRoundButton = styled(ProfileItemRoundButton)`
  box-shadow: 2px 4px 2px 0px rgba(44, 96, 123, 0.15);

  &.MuiButton-outlined {
    padding-right: 8px;
  }
`

export const PopoverInner = styled(Box)`
  padding: 20px;
  width: 300px;
`

export const LineDivider = styled('div')`
  border: 0.5px solid #d3d3d3;
  width: 100%;
  height: 0;
  margin: 16px 0;
`

export const AddNewShortlistFooterContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const AddIconCircle = styled('div')`
  border: 1.5px solid ${colors.primary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
`

export const ClearInputIcon = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
`

export const ShortlistItemsContainer = styled('div')`
  margin-left: -10px;
  max-height: 220px;
  overflow-y: auto;

  ${(props: { $withScrollBar?: boolean; $maxHeight?: string }) => {
    const defaultCss = `max-height: ${props.$maxHeight || '220px'};`

    return props.$withScrollBar
      ? css`
          {defaultCss}
          border-top: 0.5px solid #d3d3d3;
          border-bottom: 0.5px solid #d3d3d3;
          padding: 5px 0;
        `
      : defaultCss
  }}
`

export const AddIconWrapper = styled('div')`
  background: ${colors.primary};
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const StyledAddIcon = styled(AddIcon)`
  color: white;
`

export const StyledShortlistIcon = styled(ShortlistIcon)`
  color: ${colors.white};
`
export const StyledArrowOutwardIcon = styled(ArrowOutwardIcon)`
  width: 12px;
  margin-left: 4px;
  visibility: hidden;
`

export const SelectedShortlistTitle = styled(Typography)`
  color: ${colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  word-break: break-word;
  &:hover {
    color: #b8e7ff;

    & ${StyledArrowOutwardIcon} {
      visibility: visible;
    }
  }
`
